/**
 * Ordered setup steps for new tenants. Shown when the step’s nav key is in palette / app scope.
 *
 * `checkKey` maps to logic in useTenantOnboardingStatus.
 */
export const ONBOARDING_STEPS = [
  {
    id: "plants",
    navKey: "plants",
    order: 10,
    title: "Add your first plant",
    description:
      "Create at least one plant or site. Most modules attach data to a plant.",
    checkKey: "plants",
  },
  {
    id: "departments",
    navKey: "departments",
    order: 20,
    title: "Set up departments",
    description:
      "Define departments so users and work can be organized correctly.",
    checkKey: "departments",
  },
  {
    id: "shifts",
    navKey: "shifts",
    order: 30,
    title: "Define shifts",
    description:
      "Add working shifts for scheduling, OEE, and production tracking.",
    checkKey: "shifts",
  },
  {
    id: "areas",
    navKey: "areas",
    order: 40,
    title: "Define areas",
    description:
      "Map areas within plants for routing, safety, and maintenance.",
    checkKey: "areas",
  },
  {
    id: "users",
    navKey: "users",
    order: 50,
    title: "Invite your team",
    description:
      "Add at least one more user besides yourself so others can collaborate.",
    checkKey: "users",
  },
  {
    id: "asset-master",
    navKey: "asset-master",
    order: 60,
    title: "Register machines / assets",
    description:
      "Add machines or assets so work orders, OEE, and PM can target equipment.",
    checkKey: "machines",
  },
  {
    id: "loss-types",
    navKey: "loss-types",
    order: 70,
    title: "Configure OEE loss types",
    description:
      "Define loss categories for downtime and OEE analytics (needed for OEE).",
    checkKey: "lossTypes",
  },
];
